const _ = require('lodash');
const moment = require('moment');

function customValidation () {
	const cyrrilicOnly = {
		validator: function (v) {
			v = _.trim(v);
			return !v || /^[ЁА-Я]+([ЁА-Я]*[\s\-\']{0,1}[ЁА-Я]+)*$/i.test(v);
		},
		message: 'только кириллица',
	};

	const DATE_FORMAT = 'DD.MM.YYYY';

	const date = {
		validator: function (v) {
			v = _.trim(v);
			return !v || moment(v, DATE_FORMAT).isValid();
		},
		message: 'введите корректную дату',
	};

	const today = function () {
		return moment().format('DD.MM.YYYY');
	};
	const eighteen = function () {
		return moment().subtract(18, 'year').format('DD.MM.YYYY');
	};
	const dateAfter = {
		params: '01.01.1900',
		validator: function (v, param) {
			v = _.trim(v);
			const m = moment(v, DATE_FORMAT);
			const p = moment(param, DATE_FORMAT);
			p.add(-1, 'd');
			return !v || (m.isValid() && m.isAfter(p));
		},
		message: 'введите дату не ранее {0}',
	};

	const dateBefore = {
		params: '01.01.2016',
		validator: function (v, param) {
			v = _.trim(v);
			const m = moment(v, DATE_FORMAT);
			const p = moment(param, DATE_FORMAT);
			p.add(1, 'd');
			return !v || (m.isValid() && m.isBefore(p));
		},
		message: 'введите дату не больше {0}',
	};

	const regNumber = {
		validator: function (v) {
			// eslint-disable-next-line max-len
			const re = /^[0-9АВЕКМНОРСТУХавекмнорстух]\d{3}[0-9АВЕКМНОРСТУХавекмнорстух]{2}\s*\d{2,3}$/i;
			return !v || re.test(v);
		},
		message: 'введите корректный регистрационный номер',
	};

	const maxFileSize = {
		params: 1024 * 1024,
		validator: function (v, max) {
			return !_.find(v, function (f) {
				return f.Size() > max;
			});
		},
		message: 'размер файлов не может быть больше 1 Мб',
	};

	function consecutiveCharRepetitionLimit () {
		return {
			validator: function (value, params){
				if (!params.onlyIf()) {
					return true;
				}

				let result = true;
				if (!value) {
					return result;
				}
				const MAX_CONSECUTIVE_CHARS = 8;
				value = String(value);
				value = value.replace(/\s+/g, '');
				const valueChars = value.split('');
				const sameGroups = [];
				_.each(valueChars, function (val, index){
					if (index > 0 && valueChars[index - 1] === val) {
						sameGroups[sameGroups.length - 1] += val;
					} else {
						sameGroups.push(val);
					}
				});
				_.each(sameGroups, function (val){
					if (val.length > MAX_CONSECUTIVE_CHARS) {
						result = false;
					}
				});
				return result;
			},
			message: 'Некорректное значение',
			params: {
				onlyIf: function () {
					return true;
				},
			},
		};
	}

	return {
		today: today,
		eighteen: eighteen,
		cyrrilicOnly: cyrrilicOnly,
		dateAfter: dateAfter,
		dateBefore: dateBefore,
		regNumber: regNumber,
		maxFileSize: maxFileSize,
		date: date,
		consecutiveCharRepetitionLimit: consecutiveCharRepetitionLimit,
	};
}

module.exports = customValidation();
